export { default } from './TitleWrapper';